<div style="padding: 8px 24px">
  <div class="flex flex-col mt-6">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
        <div class="flex items-center justify-between gap-2">
          <button
            type="button"
            (click)="filasExpanded = !filasExpanded"
            [attr.aria-expanded]="filasExpanded"
            class="flex items-center gap-1.5 text-left"
          >
            <span
              class="text-lg transition-transform duration-200 text-chathams-blue"
              [ngClass]="filasExpanded ? 'rotate-90' : ''"
            >
              &rsaquo;
            </span>
            <span class="font-bold text-chathams-blue">
              Minhas filas de atendimento
              <span class="ml-1 font-normal text-gray-500">({{ minhasFilas.length }})</span>
            </span>
          </button>

          <div class="flex items-center gap-2">
            <p class="font-semibold">
              Status atual:
              <span [ngClass]="isAvailable ? 'text-green-500' : 'text-red-500'">
                {{ isAvailable ? 'Disponível' : 'Indisponível' }}
              </span>
            </p>
            <button (click)="toggleState()" class="btn btn--secondary px-5 h-9 leading-4 text-center">
              Trocar status
            </button>
          </div>
        </div>

        <!-- Minhas filas de atendimento -->
        <div *ngIf="filasExpanded" class="mt-4 mb-6">
          <div *ngIf="carregandoFilas" class="py-3 text-sm text-gray-500">Carregando filas...</div>

          <div
            *ngIf="!carregandoFilas && minhasFilas.length === 0"
            class="px-4 py-6 text-sm text-center text-gray-500 border border-gray-200 border-dashed rounded-md"
          >
            Você não participa de nenhuma fila de atendimento.
          </div>

          <div *ngIf="!carregandoFilas && minhasFilas.length > 0" class="overflow-x-auto">
            <table class="min-w-full">
              <thead class="border-b border-gray-400">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue"
                  >
                    Empresa
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue"
                  >
                    Descrição
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white hover:bg-iceberg" *ngFor="let fila of minhasFilas">
                  <td class="px-6 py-4 pl-0 whitespace-nowrap">
                    <span
                      class="inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full"
                      [ngClass]="fila.active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'"
                    >
                      {{ fila.active ? 'Ativa' : 'Inativa' }}
                    </span>
                  </td>
                  <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                    {{ fila.company.name }}
                  </td>
                  <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue">
                    {{ fila.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr class="my-6 border-t border-gray-300" />

        <div class="overflow-hidden">
          <table class="min-w-full">
            <thead class="border-b border-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Nome do solicitante
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 pl-0 font-bold tracking-wider text-center uppercase text-chathams-blue"
                >
                  Empresa
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 pl-0 font-bold tracking-wider text-center uppercase text-chathams-blue"
                >
                  Motivo
                </th>
                <!-- <th scope="col"
                  class="px-6 py-3 pl-0 font-bold tracking-wider text-center uppercase text-chathams-blue">
                  Posição na fila
                </th> -->
                <th
                  scope="col"
                  class="px-6 py-3 pl-0 font-bold tracking-wider text-center uppercase text-chathams-blue"
                >
                  Ação
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white hover:bg-iceberg" *ngFor="let queueItem of queueArray">
                <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                  {{ queueItem.user.fullName }}
                </td>
                <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                  <div class="flex items-center justify-center">
                    {{ queueItem?.companyName }}
                  </div>
                </td>
                <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                  <div class="flex items-center justify-center">
                    {{ queueItem?.reason }}
                  </div>
                </td>
                <!-- <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                  <div class="flex items-center justify-center">
                    {{ queueItem.position }}
                  </div>
                </td> -->
                <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                  <div class="flex items-center justify-center">
                    <button
                      title="Iniciar Atendimento"
                      (click)="onClick(queueItem.user.id, queueItem.meetingData, queueItem.meetingUrl)"
                      class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
                    >
                      Iniciar Atendimento
                    </button>
                  </div>
                </td>
              </tr>
              <app-meeting-room></app-meeting-room>
              <app-jitsi-meeting>
                <app-patient-health-panel
                  *ngIf="currentUser && showPatientData"
                  [userId]="currentUser.user.id"
                  [patientName]="currentUser.user.fullName"
                ></app-patient-health-panel>
              </app-jitsi-meeting>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
